// HeyGen is temporarily disabled for new creation. The UI must treat anything
// other than an explicit `true` from the server as disabled (fail-closed), so a
// failed or slow status request never offers a feature the backend will reject.
export const HEYGEN_DISABLED_NOTICE = "Fitur video avatar HeyGen sedang dinonaktifkan sementara. Riwayat video dan kredit Anda tidak terpengaruh.";

// B16: a badge reflects what the server reported, never a default. `configured` is a presence flag,
// not a provider health check, so the copy says "dikonfigurasi", not "berfungsi".
export const configState = (status, key, failed = false) => {
  if (status) return status[key]?.configured === true ? "configured" : "unconfigured";
  return failed ? "error" : "loading";
};

export const heygenCreationEnabled = (status) => status?.heygen?.creation_enabled === true;

// Layout and several pages ask for the flag and are re-mounted on every
// navigation. Share one in-flight/short-lived result per loader; never cache a
// failure, and always resolve a failure to `false` (fail-closed).
export const createCachedFlagLoader = (fetchStatus, { ttl = 30000, now = Date.now } = {}) => {
  let cached = null;
  return () => {
    const at = now();
    if (cached && at - cached.at < ttl) return cached.promise;
    const entry = { at, promise: null };
    entry.promise = Promise.resolve()
      .then(fetchStatus)
      .then(heygenCreationEnabled)
      .catch(() => { if (cached === entry) cached = null; return false; });
    cached = entry;
    return entry.promise;
  };
};
